'use strict';
const angular = require('angular');

export class serviceRequestToWorkorderFormComponent {
  /*@ngInject*/
  constructor(WorkOrderCodesService) {

    WorkOrderCodesService.query(data => {
      this.codes = data.map(code => code.code);
    });

    this.closeServiceRequest = true;
  }

  $onInit = function () {
    this.config = this.resolve.config;

    this.serviceRequest = this.config.data;
    this.code = this.serviceRequest.code;
  };

  ok() {
    this.close({$value: {
      code: this.code,
      note: this.note,
      close: this.closeServiceRequest
    }});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduu.serviceRequestToWorkorderForm', [])
  .component('serviceRequestToWorkorderForm', {
    template: require('./service-request-to-workorder-form.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: serviceRequestToWorkorderFormComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/service-request-to-workorder-form/service-request-to-workorder-form.component.js